/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SubscriptionCode = {
    properties: {
        code: {
            type: 'string',
            isRequired: true,
        },
        subscriptionType: {
            type: 'SubscriptionTypeEnum',
            isRequired: true,
        },
        validUntil: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        expiresAfterDays: {
            type: 'number',
            isRequired: true,
        },
        claimDate: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'date-time',
            }, {
                type: 'null',
            }],
        },
        expired: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
